import Vue from "vue";

Vue.mixin({
    methods: {
        $getShowingPage(page, filter) {
            let result = {
                startPage : (page - 1) * filter.perPage + 1,
                endPage : page * filter.perPage
            }
        return result;
      }    
    }
})